import { readSlidesData, readSummaryMediaUrl } from './dom-data.js';

const preloadedAssets = new Set();

function ensurePreloadHost() {
  let host = document.querySelector('[data-app-preloaders]');
  if (host) {
    return host;
  }

  host = document.createElement('div');
  host.hidden = true;
  host.setAttribute('data-app-preloaders', '');
  document.body.appendChild(host);
  return host;
}

function readBackgroundImageUrl(node) {
  if (!node) {
    return '';
  }

  const raw = node.style.backgroundImage || '';
  const match = raw.match(/^url\((['"]?)(.*?)\1\)$/);
  return match ? match[2] : '';
}

function preloadImage(src) {
  if (!src) {
    return;
  }

  const key = 'image:' + src;
  if (preloadedAssets.has(key)) {
    return;
  }

  const img = new Image();
  img.decoding = 'async';
  img.src = src;
  preloadedAssets.add(key);
}

function preloadMedia(src, type) {
  if (!src || !type) {
    return;
  }

  const key = type + ':' + src;
  if (preloadedAssets.has(key)) {
    return;
  }

  const media = document.createElement(type);
  media.preload = 'auto';
  media.src = src;

  if (type === 'video') {
    media.muted = true;
    media.playsInline = true;
    media.setAttribute('playsinline', '');
  }

  try {
    media.load();
  } catch (e) {}

  ensurePreloadHost().appendChild(media);
  preloadedAssets.add(key);
}

export function scheduleIdle(callback, delay) {
  const wait = typeof delay === 'number' ? delay : 0;

  window.setTimeout(function () {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () {
        callback();
      });
      return;
    }

    callback();
  }, wait);
}

export function createAssetPreloader(appRoot) {
  const slidesScope = appRoot.querySelector('.slides-flow') || appRoot;
  const slides = readSlidesData(slidesScope);
  const summaryRoot = appRoot.querySelector('.summary-page');
  const summaryImages = summaryRoot
    ? Array.from(summaryRoot.querySelectorAll('.summary-page__bg')).map(readBackgroundImageUrl)
    : [];
  const summaryMedia = readSummaryMediaUrl(summaryRoot);
  const summaryPlayerTracks = summaryRoot
    ? Array.from(summaryRoot.querySelectorAll('.summary-player')).map(function (player) {
        return {
          video: player.getAttribute('data-video') || '',
          audioMild: player.getAttribute('data-audio-mild') || '',
          audioModerate: player.getAttribute('data-audio-moderate') || '',
          audioSevere: player.getAttribute('data-audio-severe') || ''
        };
      })
    : [];

  function preloadSlide(index) {
    const slide = slides[index];
    if (!slide) {
      return;
    }

    preloadImage(slide.image);
    preloadMedia(slide.video, 'video');
    preloadMedia(slide.audioMild, 'audio');
    preloadMedia(slide.audioModerate, 'audio');
    preloadMedia(slide.audioSevere, 'audio');
  }

  function preloadSummary() {
    summaryImages.forEach(preloadImage);
    preloadMedia(summaryMedia, 'video');
    summaryPlayerTracks.forEach(function (track) {
      preloadMedia(track.video, 'video');
      preloadMedia(track.audioMild, 'audio');
      preloadMedia(track.audioModerate, 'audio');
      preloadMedia(track.audioSevere, 'audio');
    });
  }

  return {
    preloadSlide,
    preloadSummary
  };
}
